import * as io from 'socket.io-client';
import { Injectable } from '@angular/core';
import { GN } from './gn';
import { VehicleService } from './vehicles';
import * as moment from 'moment';

@Injectable()


export class SocketImplementation {

    socket: any;

    constructor(public gn: GN, public vs: VehicleService) {

    }

    connect() {
        var _this = this;
        if (this.socket != null) {
            if (this.socket.connected == true) { return }
        }
        var urlSocket = '/';

        //this.socket = io.connect(urlSocket, {
        // this.socket = io.connect('http://10.197.116.114', {
        //this.socket = io.connect('/', {
        //nlb
        //this.socket = io.connect('http://10.197.116.114', {
        //this.socket = io.connect('https://panorama.gps.mk', {

        var _urlP = 'https://panorama.gps.mk'
        if (location.origin.indexOf('iliving') > -1) {
            _urlP = 'https://panorama.iliving.mk/'
        }

        this.socket = io.connect(_urlP, {
            // this.socket = io.connect('https://panoramatest.gps.mk', {
            //this.socket = io.connect('http://18.198.112.91', {
            'path': '/io',
            'forceNew': true,
            'reconnection': true,
            'reconnectionDelay': 500,
            'reconnectionAttempts': 5,
            transports: ['polling', 'websocket']
        })
        // console.log(this.socket);
        this.socket.on('error', function (__err) {
            // _this.gn.showConnectionToast()
            if (this.socket != null) {
                if (this.socket.connected == true) { return }
            }
            // console.log(__err)
            // console.log("ERROR: Failed to reconnect. Lets try that again in 5 seconds.");
            var _that = this;
            setTimeout(function () { _that.disconnect(); _that.connect() }, 5000);

            // return this.retText
        })
        this.socket.on("reconnecting", function (attempt) {
            if (attempt === 5) {
                if (this.socket != null) {
                    if (this.socket.connected == true) { return }
                }
                var _that = this;
                setTimeout(function () { _that.disconnect(); _that.connect() }, 5000);
                // console.log("RECONNECTING: Failed to reconnect. Lets try that again in 5 seconds.");
            } else {
                if (this.socket != null) {
                    if (this.socket.connected == true) { return }
                }
                // console.log('Try reconnect #' + attempt)

            }
        })
        this.socket.on('connect', function () {
            _this.gn.hideConnectionToast()
            // console.log('Connected')
            // _this.emit({uid: _this.gn.user.id, token: _this.gn.user.token, platform: _this.gn.userPlatform}, null, 'MyData')
            //TODO
            _this.sendMyData()

        })
        this.socket.on('disconnect', function () {
            // _this.gn.showConnectionToast()            
        })
        this.socket.on('message', function (_data) {

            // console.log("Message: ")
            // console.log(_data)
            if (_data.callback != null) {
                if (_data.callback != "") {
                    window[_data.callback + ''](_data.data)
                    window[_data.callback] = null;
                }
            }
        })
        this.socket.on('impulse', function (_data) {
            _this.gn.onImpulse(_data)
        })
        this.socket.on('serverDT', function (_data) {
            // console.log(_data)
            _this.gn.myTime = moment(_data).add(_this.gn.user.TimeZone, 'hours').toDate()
            // gn.ServerDateTime = _data   
        })

        this.socket.on('reloadbeaconprocesshome', function (_data) {
            var _that = _this
            _this.gn.reloadWorkOrders(_data.type);
        })

        //Start LOGOUT - edit user - user deactivated or changed password
        this.socket.on('notifyeditusers', function (_data) {
            if (_data.uid + '' == _this.gn.user.UserId + '')
                _this.gn.do_logout();
        })
        //End LOGOUT - edit user - user deactivated or changed password

        this.socket.on('indoordata', function (_data) {
            //_this.gn.allDevices[60] = []
            var _datetime = _data.datetime.replace(/'/g, "")
            var found = false;
            var foundj = -1;
            // var _cntRoom = 0;
            // debugger;

            for (var i = 0; i < _this.gn.allDevices.length; i++) {
                if (_this.gn.allDevices[i] != undefined) {
                    for (var j = 0; j < _this.gn.allDevices[i].length; j++) {
                        if (_this.gn.allDevices[i][j].beaconid + '' == _data.beaconid + '') {
                            //if(_this.gn.allDevices[i][j].vehid + '' == _data.vehicleid + '') {
                            if (_data.datetimetype == 'deregistered') {
                                if (_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]]] != undefined) {
                                    if (_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid] != undefined) {
                                        if (_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid][j] != undefined) {
                                            //if (_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid][j].enddt == '/') {
                                            // _cntRoom = _this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].cnt;
                                            // _cntRoom--;
                                            //}
                                            var _enddt = moment(_datetime).format(_this.gn.user.DFormat + ' ' + _this.gn.user.TFormat)
                                            _this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid][j].enddt = _enddt
                                            // if (_cntRoom < 0) _cntRoom = 0;
                                            // if (_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid] != undefined) {
                                            //     console.log('BROJ1', _this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].registration, _this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid, _cntRoom)
                                            //     _this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].cnt = _cntRoom
                                            // }
                                        }
                                    }
                                }
                            }
                            //}
                            // found = true;
                            // foundj = j;
                            if (_data.datetimetype == 'registered') {
                                // console.log('SPLICE ', _this.gn.Beacons.find(beacon => beacon.beaconid === _data.beaconid).vehicle)
                                // console.log(_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid])
                                // console.log(j)
                                //_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].splice(j, 1);
                                _this.gn.allDevices[i].splice(j, 1);
                                // _cntRoom = _this.gn.allDevices[i].cnt - 1;
                                // if (_cntRoom < 0) _cntRoom = 0;
                                //console.log('BROJ2', _this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].registration, _this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid, _cntRoom)
                                // _this.gn.allDevices[i].cnt = _cntRoom
                                // var _cnt = _this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].cnt - 1
                                // _this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].cnt = _cnt < 0 ? 0 : _cnt;
                            }
                            //break;
                        } else {

                        }



                    }
                }
            }
            if (_data.datetimetype == 'registered') {
                if (_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]]] != undefined) {
                    if (_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid] != undefined) {
                        var driver = _this.gn.Beacons.find(beacon => beacon.beaconid === _data.beaconid)

                        var start1 = moment(_datetime, "YYYY-MM-DD");
                        var end1 = moment(moment(), "YYYY-MM-DD");
                        var seconds = moment.duration(end1.diff(start1)).asSeconds();

                        _this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].push({
                            beaconid: _data.beaconid,
                            vehid: _data.vehicleid,
                            orgcolor: _this.gn.Organisations.find(org => org.id + '' === driver.organisationid + '').color,
                            fullname: driver.vehicle,
                            code: driver.code,
                            dt: moment(_datetime).format(_this.gn.user.DFormat + ' ' + _this.gn.user.TFormat),
                            enddt: '/',
                            duration: seconds,
                            visible: true,
                            orgid: driver.organisationid
                        })
                        // _cntRoom = _this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].cnt;
                        // _cntRoom++;
                        // if (_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid] != undefined) {
                        //     //console.log('BROJ3', _this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].registration, _this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid, _cntRoom)
                        //     //_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].cnt = _cntRoom
                        // }

                        //var _cnt1 = _this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].cnt + 1
                        //_this.gn.allDevices[_this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].roomid].cnt = _cnt1
                    }
                }
            }


            //console.log('KIKI', _data.datetimetype, _this.gn.Beacons.find(beacon => beacon.beaconid === _data.beaconid).vehicle, _this.gn.Vehicles[_this.gn.VehiclesDic[_data.vehicleid]].registration)
            //console.log(_data)
            //debugger

            var _cntRoom = 0;
            for (var i = 0; i < _this.gn.allDevices.length; i++) {
                _cntRoom = 0;
                if (_this.gn.allDevices[i] != undefined) {
                    for (var j = 0; j < _this.gn.allDevices[i].length; j++) {
                        if (_this.gn.allDevices[i][j].enddt == '/') {
                            _cntRoom++;
                        }

                    }
                    _this.gn.allDevices[i].cnt = _cntRoom
                }
            }
        })

        //mebel vi nalozi
        this.socket.on('sendreloadedworkorder', function (_data) {
            for (let i = 0; i < _data.data.length; i++) {
                _data.data[i].dt = moment(_data.data[i].dt).format(_this.gn.user.DFormat) + ' ' + moment(_data.data[i].dt).format(_this.gn.user.TFormat)
            }
            if (_this.gn.pin.pinid + '' == _data.pinid + '')
                _this.gn.workoders = _data.data

            for (var i = 0; i < _this.gn.workoders.length; i++) {
                _this.gn.workoders[i].Visible = true
            }
        })

        this.socket.on('sendnotifforroute', function (_data) {
            _this.gn.routesChanges[_data.heder] = 1
            _this.gn.routesChangesPois.push(_data.heder + '-' + _data.rbr)


            var tf = false;
            for (var i = 0; i < _this.gn.routesChangesTest.length; i++) {
                if (_this.gn.routesChangesTest[i].hederrbr == _data.heder + '-' + _data.rbr) {
                    _this.gn.routesChangesTest[i] = ({ hederrbr: (_data.heder + '-' + _data.rbr), note: _data.note, visited: _data.visited })
                    tf = true;
                }
            }
            if (!tf) {
                _this.gn.routesChangesTest[_this.gn.routesChangesTest.length] = ({ hederrbr: (_data.heder + '-' + _data.rbr), note: _data.note, visited: _data.visited })
            }

            _this.gn.routesCh1 = _this.gn.routesChangesTest.map(function (a) {
                return a.hederrbr;
            }
            );
            _this.gn.routesCh2 = _this.gn.routesChangesTest.map(function (a) {
                return a.note;
            }
            );
            _this.gn.routesCh3 = _this.gn.routesChangesTest.map(function (a) {
                return a.visited;
            }
            );
        })

        this.socket.on('sendbankforroute', function (_data) {
            _this.gn.routesChanges[_data.heder] = 1
            _this.gn.routesChangesPois.push(_data.heder + '-' + _data.rbr)


            var tf = false;
            for (var i = 0; i < _this.gn.routesChangesTest.length; i++) {
                if (_this.gn.routesChangesTest[i].hederrbr == _data.heder + '-' + _data.rbr) {
                    _this.gn.routesChangesTest[i] = ({ hederrbr: (_data.heder + '-' + _data.rbr), amount: _data.amount, person: _data.person, barcode: _data.barcode, dtbank: _data.dtbank })
                    tf = true;
                }
            }
            if (!tf) {
                _this.gn.routesChangesTest[_this.gn.routesChangesTest.length] = ({ hederrbr: (_data.heder + '-' + _data.rbr), amount: _data.amount, person: _data.person, barcode: _data.barcode, dtbank: _data.dtbank })
            }

            _this.gn.routesCh4 = _this.gn.routesChangesTest.map(function (a) {
                return a.hederrbr;
            }
            );
            _this.gn.routesCh5 = _this.gn.routesChangesTest.map(function (a) {
                return a.amount;
            }
            );
            _this.gn.routesCh6 = _this.gn.routesChangesTest.map(function (a) {
                return a.person;
            }
            );
            _this.gn.routesCh7 = _this.gn.routesChangesTest.map(function (a) {
                return a.barcode;
            }
            );
            _this.gn.routesCh8 = _this.gn.routesChangesTest.map(function (a) {
                return a.dtbank;
            }
            );
        })

        this.socket.on('stream', function (_data) {
            //console.log('STREAM')

            var v = _this.vs.parseData(_data)
            if (v == null) return
            var _oldv = _this.gn.Vehicles[_this.gn.VehiclesDic[v.vehicleid]]
            if (_oldv != null) {
                v.nopay = _oldv.nopay
                v.lastpaydt = _oldv.lastpaydt

                if (v.nopay == '1') {
                    v.color = 'Gray'
                    v.datumformated = v.lastpaydt
                }

                v.roaddirection = _oldv.roaddirection
                v.orgcolor = _oldv.orgcolor
                v.visible = _oldv.visible
                v.organisationid = _oldv.organisationid
                v.orgname = _oldv.orgname
                v.consumptionbyhour = _oldv.consumptionbyhour
                v.brand = _oldv.brand
                v.armed = _oldv.armed

                v.multiplefueltypes = _oldv.multiplefueltypes
                v.approve = _oldv.approve
                v.suspend = _oldv.suspend

                v.typeid = _oldv.typeid
                v.printtravelorder = _oldv.printtravelorder
                v.alias = _oldv.alias
                v.model = _oldv.model
                v.albletemp = _oldv.albletemp
                v.alrpm = _oldv.alrpm
                v.showrpm = _oldv.showrpm
                //v.driver = _oldv.driver
                v.altemp = _oldv.altemp
                v.alfuel = _oldv.alfuel
                v.fuel = _oldv.fuel
                v.allowultrasonic = _oldv.allowultrasonic
                v.allowgarmin = _oldv.allowgarmin
                v.allowengineblock = _oldv.allowengineblock

                //v.ufuel = _oldv.ufuel
                v.alcanbas = _oldv.alcanbas
                v.engineworktimetype = _oldv.engineworktimetype
                v.AllowCANbus = _oldv.AllowCANbus
                v.a_cbd = _oldv.a_cbd
                v.a_cbr = _oldv.a_cbr
                v.a_cbf = _oldv.a_cbf
                v.a_cbt = _oldv.a_cbt

                v.speedlimitalertallow = _oldv.speedlimitalertallow
                v.allowdraeger = _oldv.allowdraeger

                v.dashboard = _oldv.dashboard

                v.slot1name = _oldv.slot1name
                v.a_bletemp1 = _oldv.a_bletemp1
                v.a_blehumidity1 = _oldv.a_blehumidity1
                v.a_blebattery1 = _oldv.a_blebattery1

                v.slot2name = _oldv.slot2name
                v.a_bletemp2 = _oldv.a_bletemp2
                v.a_blehumidity2 = _oldv.a_blehumidity2
                v.a_blebattery2 = _oldv.a_blebattery2

                v.slot3name = _oldv.slot3name
                v.a_bletemp3 = _oldv.a_bletemp3
                v.a_blehumidity3 = _oldv.a_blehumidity3
                v.a_blebattery3 = _oldv.a_blebattery3

                v.slot4name = _oldv.slot4name
                v.a_bletemp4 = _oldv.a_bletemp4
                v.a_blehumidity4 = _oldv.a_blehumidity4
                v.a_blebattery4 = _oldv.a_blebattery4

                v._AllowedPKSABH = _oldv._AllowedPKSABH
                v._AllowedSovozac = _oldv._AllowedSovozac
                v.allowbattery = _oldv.allowbattery
                v._AllowSTP = _oldv._AllowSTP
                v.searchVisible = _oldv.searchVisible
                v.vehtype = _oldv.vehtype
                v.ismachine = _oldv.ismachine

                v.tmpVisible = _oldv.tmpVisible
                v.poinames = _oldv.poinames
                v.equipment = _oldv.equipment
                v.cancontrol = _oldv.cancontrol

                v.allowfuelpulses = _oldv.allowfuelpulses
                v.totalfuelused = _oldv.totalfuelused
                v.istank = _oldv.istank
                v.isdigalkanalogna = _oldv.isdigalkanalogna
                v.allowfuel = _oldv.allowfuel
                v.allowtacho = _oldv.allowtacho
                v.allowbeacon = _oldv.allowbeacon
                v.allowdriverfrombeacon = _oldv.allowdriverfrombeacon
                v.electric = _oldv.electric
                v.nextservicewhours = _oldv.nextservicewhours
                v.roomid = _oldv.roomid

                // if (_oldv.sopatnik == '-')
                //     v.sopatnik = '-'

                //console.log(2)
                _this.gn.Vehicles[_this.gn.VehiclesDic[v.vehicleid]] = v

                //if (v.ignition + '' == '1' && v.zoneids + '' != '') {
                for (var k = 0; k < _this.gn.VehiclesSortDt.length; k++) {
                    if (_this.gn.VehiclesSortDt[k].vehicleid == v.vehicleid) {
                        var _tmpdtzone = _this.gn.VehiclesSortDt[k].fulldt

                        if (_this.gn.VehiclesSortDt[k].zoneids + '' != v.zoneids + '') {
                            _this.gn.VehiclesSortDt[k] = v
                            //console.log(v.code + ' ' + v.fulldt + ' ' + _this.gn.VehiclesSortDt[k].zoneids + ' ' + v.zoneids)
                            _this.gn.VehiclesSortDt[k].dtzone = moment(v.fulldt)
                            _this.gn.VehiclesSortDt[k].dtzoneymd = v.fulldt
                        } else {
                            _this.gn.VehiclesSortDt[k] = v
                            _this.gn.VehiclesSortDt[k].dtzone = moment(_tmpdtzone)
                            _this.gn.VehiclesSortDt[k].dtzoneymd = _tmpdtzone
                            _this.gn.VehiclesSortDt[k].fulldt = _tmpdtzone
                        }

                        _this.gn.VehiclesSortDt.sort(_this.sortFunction);
                    }
                }
                //}

                _this.vs.moveVehicle(v.code, parseFloat(v.lon), parseFloat(v.lat))
                _this.vs.setVehicleColor(v.code, v.color, v, 1)
            }

            // gn.stream.parser(_data)
            // gn.vehicles.stream(_data)
            //gn.stream.parser('3|22.110148|41.476125|Green|0|28-06-2017 14:26:50||87.000000|0|0|0||Александар Македонски A1, Кавадарци, Македонија|SK-0003-AB|0|2017-06-28 14:26:50.399|8.5000000000000000|2304.000000|0.000000|291999900.000000|0.000000|0.000000||0|-103051|1|/|2058|1|0|0|0 rpm|John Smith|0|070123123|0|/|0|/|0|0|/|Ministerstvo')
            // 
        })

    }

    sortFunction(a, b) {
        var dateA = new Date(a.dtzone).getTime();
        var dateB = new Date(b.dtzone).getTime();
        return dateA > dateB ? 1 : -1;
    };

    disconnect() {
        // this.gn.showConnectionToast()
        this.socket.disconnect();
    }

    destroy() {
        this.socket = null;
        // console.log("destroy");
    }

    isConnected() {
        if (this.socket == null) { return false }
        return this.socket.connected
    }

    checkConnection() {
        if (this.socket == null) { return }
        if (this.socket.connected == false) {
            // console.log('gn.checkConnection: FALSE')
        } else {
            // console.log('gn.checkConnection: TRUE')
            // this.emit({cid: this.cid, uid: this.uid}, function(_data){}, 'SetMyData') 
        }
    }

    emit(_data, _callback, _type) {
        if (_type == null) { _type = "message" }
        if (_type == "") { _type = "message" }
        var _that = this
        if (this.socket == null) {
            setTimeout(function () {
                _that.emit(_data, _callback, _type)
            }, 500)
            return
        }
        if (this.socket.connected == true) {
            if (_callback != null) {
                var fnName = 'dblfun' + this.gn.rnd()
                window[fnName] = _callback
                _data.callback = fnName
            }
            // console.log('Send [' + _type + '] to  server: ', _data)
            this.socket.emit(_type, _data);
        } else {
            setTimeout(function () {
                _that.emit(_data, _callback, _type)
            }, 500)
        }
    }
    sendMyData() {
        // console.log('vleze vo sendMyData')
        if (this.socket.connected == true) {
            this.emit({ cid: this.gn.user.ClientId, uid: this.gn.user.UserId, token: this.gn.PushToken }, null, 'SetMyData')
            // console.log('vleze vo sendMyData A')
        } else {
            // console.log('vleze vo sendMyData B')
            var _that = this
            setTimeout(function () {
                _that.sendMyData()
            }, 500)
        }
    }
}


// WEBPACK FOOTER //
// ./src/socket.ts